import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import Logo from "../assets/images/Logo2.png";
import { useAuth } from "../hooks/useAuth";

// Import Icons
import HomeIcon from "../assets/icons/home-icon.svg";
import DashboardIcon from "../assets/icons/User-dashboard.svg";
import HeadphoneIcon from "../assets/icons/I06-headphone.svg";
import QuestionIcon from "../assets/icons/I07-question.svg";
import AdminIcon from "../assets/icons/icons8_registration.svg";

import HomeIconFull from "../assets/icons/home-icon_full.svg";
import DashboardIconFull from "../assets/icons/User-dashboard_full.svg";
import HeadphoneIconFull from "../assets/icons/I06-headphone_full.svg";
import QuestionIconFull from "../assets/icons/I07-question_full.svg";
import AdminIconFull from "../assets/icons/icons8_registration.svg";
import ArrowDownIcon from "../assets/icons/Arrow_down.svg";

const Header = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth(onLogout);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hoveredPath, setHoveredPath] = useState(null);
  const userMenuRef = useRef(null);

  const displayName =
    user?.full_name?.trim() || user?.username?.trim() || "کاربر";
  const avatarLetter = displayName.charAt(0).toUpperCase();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Close user menu on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isUserMenuOpen]);

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/" || location.pathname === "/home";
    }
    return location.pathname.startsWith(path);
  };

  const menuItems = [
    { path: "/", label: "صفحه اصلی", icon: HomeIcon, iconFull: HomeIconFull },
    {
      path: "/dashboard",
      label: "داشبورد کاربر",
      icon: DashboardIcon,
      iconFull: DashboardIconFull,
    },
    {
      path: "/admin/users",
      label: "مدیریت کاربران",
      icon: AdminIcon,
      iconFull: AdminIconFull,
    },
    {
      path: "/contact",
      label: "تماس با ما",
      icon: HeadphoneIcon,
      iconFull: HeadphoneIconFull,
    },
    {
      path: "/about",
      label: "درباره سامانه",
      icon: QuestionIcon,
      iconFull: QuestionIconFull,
    },
  ];

  return (
    <header className="app-header">
      {/* 1. Right Side: Logo & Hamburger */}
      <div className="app-header-right">
        <button
          className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="app-header-brand">
          <img src={Logo} alt="Logo" className="app-header-logo-img" />
        </div>
      </div>

      {/* 2. Center: Navigation (Desktop & Mobile) */}
      <nav
        className={`app-header-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}
      >
        {menuItems.map((item) => {
          const active = isActive(item.path);
          const hovered = hoveredPath === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`app-header-link ${active ? "active" : ""}`}
              onMouseEnter={() => setHoveredPath(item.path)}
              onMouseLeave={() => setHoveredPath(null)}
            >
              <img
                src={active || hovered ? item.iconFull : item.icon}
                alt={item.label}
                className="link-icon"
              />
              <span className="link-text">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* 3. Left Side: User Menu */}
      <div className="app-header-user-container" ref={userMenuRef}>
        <button
          className="app-header-user"
          onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
          aria-haspopup="true"
          aria-expanded={isUserMenuOpen}
          type="button"
        >
          <div className="app-header-user-avatar">{avatarLetter}</div>
          <span className="app-header-user-name">{displayName}</span>
          <img
            src={ArrowDownIcon}
            alt=""
            className={`app-header-user-arrow ${isUserMenuOpen ? "open" : ""}`}
            aria-hidden="true"
          />
        </button>

        {isUserMenuOpen && (
          <div className="app-header-user-menu">
            <button
              type="button"
              className="app-header-user-menu-item"
              onClick={() => {
                setIsUserMenuOpen(false);
                navigate("/profile");
              }}
            >
              پروفایل کاربری
            </button>
            <button
              type="button"
              className="app-header-user-menu-item danger"
              onClick={() => {
                setIsUserMenuOpen(false);
                logout();
              }}
            >
              خروج از سیستم
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
